import { addDays } from './format';
export function validDate(value: string | null, fallback: string) {
  if (!value || !/^\d{4}-\d{2}-\d{2}$/.test(value)) return fallback;
  const parsed = new Date(value + 'T12:00:00Z');
  return Number.isFinite(parsed.getTime()) && parsed.toISOString().slice(0, 10) === value ? value : fallback;
}
export function boundedDateRange(from: string | null, to: string | null, fallback: string, maximumDays = 92) {
  const start = validDate(from, fallback); const end = validDate(to, start);
  return { from: start, to: end < start ? start : end > addDays(start, maximumDays - 1) ? addDays(start, maximumDays - 1) : end };
}
